import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { OtherService } from 'src/app/Service/other.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MapService } from 'src/app/Service/map.service';
import axios from 'src/app/Service/axios';
import momentJalaali from 'moment-jalaali';
import * as moment from 'moment';
import * as XLSX from 'xlsx';
declare let $: any;

@Component({

  selector: 'app-cctv-film-report',

  templateUrl: './cctv-film-report.component.html',

  styleUrls: ['./cctv-film-report.component.css']

})

export class CctvFilmReportComponent implements OnInit {

  lst_Parking = [];

  lst_Car = [];

  lst_Report = [];

  lst_Search = [];

  lst_Ckecked: any = [];

  lst_Playlist: any = [];

  showCustom_Map: boolean = false;

  isPlaylist: boolean = false;

  mdl_Request: FormGroup = this.FormBuilder.group({

    iSystemUser: new FormControl(this.gurdService.decrypt(localStorage.getItem('ID')!)),

    strSession: new FormControl(this.gurdService.decrypt(localStorage.getItem('Session')!)),

    iVS_Parking: new FormControl('-1'),

    strUnitID: new FormControl(''),

    tiMediaType: new FormControl('-1'),

    strSDate: new FormControl(momentJalaali().subtract(1, 'day').format('jYYYY/jMM/jDD')),

    strEDate: new FormControl(''),


  })

  mdl_Map: FormGroup = this.FormBuilder.group({

    strAddress: new FormControl(''),

    fLon: new FormControl(''),

    fLat: new FormControl(''),

    strSource: new FormControl(''),

  })

  constructor(

    private _tooltip: NotificationService,

    private FormBuilder: FormBuilder,

    private router: Router,

    private route: ActivatedRoute,

    private gurdService: GurdServiceService,

    private _otherService: OtherService,

    private mapService: MapService

  ) { }

  ngOnInit(): void {

    this.initialization()

  }

  async initialization() {

    this._otherService.Showspinner();

    let response = JSON.parse((await axios.post(`VS_Parking_List`, this._otherService.stringNumberToNumber(this.mdl_Request.value))).data.toString());

    this._otherService.nonespinner();

    if (response.ISSessionExpired == true) {

      this._tooltip.showError('نشست کاربری شما منقضی شده است');

      this._otherService.removeLocalStorage();

      this.router.navigate(['login'], { queryParams: { error: '1dxzOPwsZ' } });

      return;

    }

    if (response.iResult == 0) return this._tooltip.showError(response.strError);

    this.lst_Parking = response;

    // -------------------------------------------------------------

    this._otherService.Showspinner();

    let response_2 = JSON.parse((await axios.post(`Dashcam_List4Search`, this._otherService.stringNumberToNumber(this.mdl_Request.value))).data.toString());

    this._otherService.nonespinner();

    if (response_2.ISSessionExpired == true) {

      this._tooltip.showError('نشست کاربری شما منقضی شده است');

      this._otherService.removeLocalStorage();

      this.router.navigate(['login'], { queryParams: { error: '1xzOPwsZ' } });

      return;

    }

    if (response_2.iResult == 0) return this._tooltip.showError(response_2.strError);

    this.lst_Car = response_2;

    // -------------------------------------------------------------

  }

  async getReport() {

    this._otherService.Showspinner();

    let response = JSON.parse((await axios.post(`VS_MediaIndex_Search`, this._otherService.stringNumberToNumber(this.mdl_Request.value))).data.toString());

    this._otherService.nonespinner();

    if (response.ISSessionExpired == true) {

      this._tooltip.showError('نشست کاربری شما منقضی شده است');

      this._otherService.removeLocalStorage();

      this.router.navigate(['login'], { queryParams: { error: '1xzOPwsZ' } });

      return;

    }

    if (response.iResult == 0) return this._tooltip.showError(response.strError);

    this.lst_Report = response;

    this.lst_Search = response;

    // console.log(response)


  }

  filter_list(val: any) {

    this.lst_Report = this.lst_Search.filter((el: any) => {

      return el.strName.includes(val.value) ||

        el.strFullName.includes(val.value) ||

        el.strCamera.includes(val.value) ||

        el.strMediaType.includes(val.value) ||

        el.iCode.toString().includes(val.value)

    });

    if (val.value.trim() == '') {

      this.lst_Report = this.lst_Search;

    }

  }

  openVideo(item: any) {

    window.open(item.strFileName, '_blank')

  }

  showMap(item) {

    if (item.fLat == 0 || item.fLon == 0) return this._tooltip.showError('مختصاتی یافت نشد!');

    this.mdl_Map.patchValue({

      strAddress: '',

      fLon: item.fLon,

      fLat: item.fLat,

      strSource: ''

    })

    this.showCustom_Map = true;

  }

  showMap_Cluster() {

    const lst_Report = [];

    for (let i = 0; i < this.lst_Report.length; i++) {

      if (this.lst_Report[i].fLat != 0 && this.lst_Report[i].fLon != 0) {

        lst_Report.push({

          fSLon: this.lst_Report[i].fLon,

          fSLat: this.lst_Report[i].fLat,

          strUnitID: this.lst_Report[i].iVS_MediaIndex

        })

      }


    }

    if (!lst_Report.length) return this._tooltip.showError('مختصاتی یافت نشد!');

    window.localStorage.removeItem('x5SBJaw');

    window.localStorage.setItem("x5SBJaw", this.gurdService.encrypt(JSON.stringify(lst_Report)));

    window.open('/emdadran/search-requests/map', '_blank')

  }

  selectAllCheckBox() {

    if (this.lst_Report.length > 0 && (this.lst_Report.length != this.lst_Ckecked.length)) {

      this.lst_Ckecked = [];

      this.lst_Report.forEach((a: any) => {

        this.lst_Ckecked.push(a.iVS_MediaIndex);

        this.lst_Playlist.push(a.strFileName);


      })

      this._tooltip.showSuccess('همه انتخاب شدند')

    }

    else {

      this.lst_Ckecked = [];

      this.lst_Playlist = [];

    }

  }

  setCheckBox(value: boolean, item: any) {

    if (value === true) {

      this.lst_Ckecked.push(item.iVS_MediaIndex);

      this.lst_Playlist.push(item.strFileName);

    }

    else {

      // remove from check list

      this.lst_Ckecked.find((value: any) => {

        if (value === item.iVS_MediaIndex) {

          const index = this.lst_Ckecked.indexOf(item.iVS_MediaIndex);

          if (index !== -1) this.lst_Ckecked.splice(index, 1);

        }

      })

      // remove from play list

      this.lst_Playlist.find((value: any) => {

        if (value === item.strFileName) {

          const index = this.lst_Playlist.indexOf(item.strFileName);

          if (index !== -1) this.lst_Playlist.splice(index, 1);

        }

      })


    }

  }

  isSelected(item: any): boolean {

    return this.lst_Ckecked.indexOf(item) !== -1;

  }

  open_Playlist() {

    this.isPlaylist = false;

    setTimeout(() => {

      this.isPlaylist = true;

      $("#playlist_Modal").modal('show');

    }, 200);


  }

  Exportexcel(id: any): void {
    /* pass here the table id */
    let element = document.getElementById(`${id}`);
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, 'مدیریت فیلم‌ها.xlsx');
  }

}
